import Listar from '@/pages/venda/Listar'
import Cadastro from '@/pages/venda/Cadastro'

export const vendasRoutes = [
    {
        path: '/vendas',
        name: 'vendas',
        component: Listar
    },
    {
        path: '/venda',
        name: 'vendaCadastro',
        component: Cadastro,
    },
    {
        path: '/venda/:id',
        name: 'vendaEditar',
        component: Cadastro,
        props: true
    },
    {
        path: '/venda-converter',
        name: 'vendaConverter',
        component: Cadastro
    }

]

export default{}